var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetflowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4724 15.7564C23.4209 15.7564 25 14.1773 25 12.2288C25 10.2804 23.4209 8.70125 21.4724 8.70125C21.4724 6.19205 19.4371 4.15673 16.9279 4.15673C16.4319 4.15673 15.9566 4.23915 15.5092 4.38631C14.8646 2.42016 13.0177 1 10.8367 1C8.11995 1 5.91834 3.38999 5.91834 6.1067C3.20164 6.1067 1 8.12141 1 10.8381C1 13.5548 3.20164 15.7564 5.91834 15.7564H8.77632V12.3436H6.71156L10.8381 6.51288L14.9647 12.3436H12.8999V19.1692H10.8352L14.9617 25L19.0883 19.1692H17.0236V15.7564H21.4754H21.4724Z",
    stroke: "#667085",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflowDefault);
export default __webpack_public_path__ + "static/media/netflow-default.fc155986565c171cd42e6dffb00f0579.svg";
export { ForwardRef as ReactComponent };